import { SearchSource } from '@carvana/merch-contracts';
import { useSearchSource } from '~/context/srp/SearchEventsDataContext';

export default function useIsFromComposer() {
  return useSearchSource() === SearchSource.Composer;
}
